<template>
  <div class="content">
    <el-container class="layout-content">
      <Aside-com></Aside-com>
      <el-container class="main-content">
        <Header-com></Header-com>
        <el-main>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" :key="rKey"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Aside from "@/components/Layout/Aside.vue";
import Header from "@/components/Layout/Header.vue";

export default {
  data() {
    return {};
  },
  components: {
    "Aside-com": Aside,
    "Header-com": Header,
  },
  computed: {
    rKey() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
}
.layout-content {
  // display: flex;
  // flex-direction: column;
  overflow: hidden;
  ::v-deep .el-container {
    height: 100%;
  }
}
.main-content {
  display: flex;
  flex-direction: column;
}
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  // text-align: center;
  // overflow-y: scroll;
  height: 100%;
  padding: 0;
}

body > .el-container {
  margin-bottom: 40px;
  height: 100%;
}
</style>
